export default __webpack_public_path__ + "static/media/05.f7f6ca3e.jpg";